import { useContext } from 'react';
import React, { useEffect, useState } from 'react';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Paper, Select, MenuItem, InputLabel, FormControl, SelectChangeEvent } from '@mui/material';
import 'src/utils/HistoryPageStyle.css';
import { AuthContext } from 'src/utils/authContext';
import HistroyService from 'src/services/history.service';
import { useNavigate } from 'react-router-dom';

const HistoryPage = () => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [page, setPage] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState<number>(5);
    const { checkAuthentication, user } = useContext(AuthContext);
    const navigate = useNavigate();
    const [quarters, setQuarters] = useState<string[]>([]);
    const [selectedQuarter, setSelectedQuarter] = useState<string>('');

    useEffect(() => {
        const CtvQuarterRequest = () => {
            HistroyService().getCtvQuarter().then(response => {
                if (response && response.ctvQuartersList) {
                    setQuarters(response.ctvQuartersList);
                } else {
                    setQuarters([]);
                }
                setLoading(false);
            }).catch((error) => {
                setQuarters([]);
                setLoading(false);
            });
        };

        CtvQuarterRequest();
    }, []);

    const histroyRequest = (selectedQuarter: string) => {
        HistroyService().getData(user.emailaddress, selectedQuarter).then(response => {
            if (response && Array.isArray(response.tpHistoryList)) {
                setData(response.tpHistoryList);
            } else {
                setData([]);
            }
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            setData([]);
        });
    };

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const goToForm = () => {
        navigate('/form');
    };

    const handleQuarterChange = (event: SelectChangeEvent<string>) => {
        const selected = event.target.value;
        setSelectedQuarter(selected);
        histroyRequest(selected);
    };

    const paginatedData = Array.isArray(data) ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : [];

    return (
        <div className="wrapper">
            {/* Dropdown and Button container */}
            <div className={`button-container ${loading ? 'fade-out' : 'fade-in'}`}>
                {/* Button for "Back to Form" */}
                <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={goToForm}
                    style={{
                    backgroundColor: 'rgb(46, 125, 50)', // Match the color from HISTORY button
                    border: 'none',
                    borderRadius: '5px',
                    color: 'white',
                    fontSize: '12px',
                    padding: '10px 10px',
                    height: '35px',
                    }}
                >
                 Back to Current Quarter
                </Button>

                {/* Dropdown for CTV Quarters */}
                <FormControl className="quarter-dropdown">
                    <InputLabel id="quarter-select-label">CTV Quarter</InputLabel>
                    <Select
                        labelId="quarter-select-label"
                        value={selectedQuarter}
                        onChange={handleQuarterChange}
                        label="CTV Quarter"
                    >
                        {quarters.map((quarter, index) => (
                            <MenuItem key={index} value={quarter}>
                                {quarter}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            {/* Loading Message with smooth transition */}
            {loading ? (
                <div className="loading-container fade-in">
                    <p>Loading data...</p>
                </div>
            ) : (
                <TableContainer component={Paper} className="table-container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className="css-mlny8k MuiTableCell-head">Program Number</TableCell>
                                <TableCell className="css-mlny8k MuiTableCell-head">Program Name</TableCell>
                                <TableCell className="css-mlny8k MuiTableCell-head">Program Type</TableCell>
                                <TableCell className="css-mlny8k MuiTableCell-head">Product Name</TableCell>
                                <TableCell className="css-mlny8k MuiTableCell-head">Response Received</TableCell>
                                <TableCell className="css-mlny8k MuiTableCell-head">Response Received Date</TableCell>
                                <TableCell className="css-mlny8k MuiTableCell-head">Submitted By</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedData.length > 0 ? (
                                paginatedData.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell className="css-mlny8k">{row.program_number}</TableCell>
                                        <TableCell className="css-mlny8k">{row.program_name}</TableCell>
                                        <TableCell className="css-mlny8k">{row.program_type}</TableCell>
                                        <TableCell className="css-mlny8k">{row.product_name}</TableCell>
                                        <TableCell className="css-mlny8k">{row.response_received}</TableCell>
                                        <TableCell className="css-mlny8k">{row.response_date}</TableCell>
                                        <TableCell className="css-mlny8k">{row.submitted_by}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={7} style={{ textAlign: 'center' }}>
                                        No records found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            )}
        </div>
    );
};

export default HistoryPage;